import { IPermission } from "@edgetier/watchtower-types";

/**
 * Check if the permission is amongst the role permissions
 * @param rolePermissions     All the role permissions
 * @param permission          Searched permission
 */
export const permissionIsChecked = (rolePermissions: IPermission[], permission: IPermission) => {
    return rolePermissions.some((rolePermission) => rolePermission.permissionId === permission.permissionId);
};
